import { TimelineMax, Expo } from 'gsap';

export default function text(el) {
  const tl = new TimelineMax({
    paused: true,
  });

  tl
    .addLabel('start')
    .to(el, 1.2, {
      x: 0,
      rotationX: 0,
      autoAlpha: 1,
      y: 0,
      ease: Expo.easeOut,
    }, 'start');

  return tl;
}
